/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SimilarIcon = ({ width = 24, height = 24, hidden = false, title = 'Similar' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.125,9.5127c-1.20508,0-2.34277-.51172-3.52441-1.28711-2.16699-1.42285-4.27246-1.27734-6.08789.41992-.30469.28223-.77734.2666-1.06055-.03516-.2832-.30273-.2666-.77734.03516-1.06055,2.3457-2.19336,5.16406-2.39941,7.9375-.57812,2.08203,1.36816,3.5918,1.62598,6.05371-.75586.29883-.28711.77344-.2793,1.06055.01758.28809.29785.28027.77246-.01758,1.06055-1.64648,1.5918-3.0625,2.21875-4.39648,2.21875Z"
      fill="currentColor"
    />
    <path
      d="M13.125,14.26172c-1.20508,0-2.34277-.51172-3.52441-1.28711-2.16309-1.42285-4.26953-1.2793-6.08887.41992-.30273.28223-.77637.26758-1.05957-.03613-.2832-.30273-.2666-.77637.03613-1.05957,2.3457-2.19336,5.16504-2.39844,7.93652-.57812,2.08203,1.36719,3.5918,1.62695,6.05371-.75586.29883-.28711.77344-.2793,1.06055.01758.28809.29785.28027.77246-.01758,1.06055-1.64648,1.5918-3.0625,2.21875-4.39648,2.21875Z"
      fill="currentColor"
    />
  </svg>`;
};
